import {http} from '@px/helper/http';

export const langApi = {
  load(path) {
    return http.get(path, {});
  },
};
